import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AddEditForm from "pages/EmployeeWorkspace/components/Tabs/components/EducationalBackgroundTab/components/AddEditForm";
import { formatDateForInput } from "utils/helpers/dateHelper";

import familyMemberSchema from "pages/EmployeeWorkspace/validation/educationBackgroundSchema";

const defaultValues = {
    schoolName: "",
    course: "",
    periodFrom: null,
    periodTo: null,
    yearGraduated: null,
    honors: ""
};

export default function FormDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(familyMemberSchema)
    });

    console.log({ item });

    useEffect(() => {
        if (open) {
            console.log({ item });
            reset({
                ...defaultValues,
                ...item,
                periodFrom: formatDateForInput(item?.periodFrom),
                periodTo: formatDateForInput(item?.periodTo)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave(data);
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? "Edit Family Member" : "Add Family Member"}
            </DialogTitle>

            <DialogContent dividers>
                <AddEditForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
